<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Liste des Tiers</h4>
            <h6>Gérer vos Tiers</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="PDF"
              @click.prevent="exportPDF"
            >
              <img src="@/assets/img/icons/pdf.svg" alt="pdf" />
            </a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Excel"
              @click.prevent="exportCSV"
            >
              <img src="@/assets/img/icons/excel.svg" alt="excel" />
            </a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Imprimer"
              @click.prevent="printTable"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Rafraîchir"
              @click.prevent="refreshList"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-units"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter
            un nouveau client</a
          >
        </div>
      </div>
      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input
                  type="text"
                  placeholder="Rechercher"
                  class="dark-input"
                  v-model="searchQuery"
                />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"
                  ><vue-feather
                    type="search"
                    class="feather-search"
                  ></vue-feather
                ></a>
              </div>
            </div>
            <div class="search-path">
              <div class="d-flex align-items-center">
                <a
                  class="btn btn-filter"
                  id="filter_search"
                  v-on:click="filter = !filter"
                  :class="{ setclose: filter }"
                >
                  <vue-feather type="filter" class="filter-icon"></vue-feather>
                  <span
                    ><img src="@/assets/img/icons/closes.svg" alt="img"
                  /></span>
                </a>
              </div>
            </div>
            <div class="form-sort">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select
                :options="CustomerDate"
                id="customerdate"
                placeholder="Trier par date"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="user" class="info-img"></i>
                    <vue-select
                      :options="CustomerName"
                      id="customerName"
                      placeholder="Choisir un client"
                      v-model="activeFilters.name"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="globe" class="info-img"></i>
                    <vue-select
                      :options="CustomerCountry"
                      id="customercountry"
                      placeholder="Choisir un pays"
                      v-model="activeFilters.country"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12 ms-auto">
                  <div class="input-blocks">
                    <a class="btn btn-filters ms-auto" @click.prevent="applyFilters">
                      <i data-feather="search" class="feather-search"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive">
            <a-table
              class="table datanew"
              :columns="columns"
              :data-source="filteredData"
              :row-selection="{}"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'CategoryName'">
                  <div class="userimgname cust-imgname">
                    <a href="javascript:void(0);" class="product-img">
                      <img
                        :src="require(`@/assets/img/${record.Image}`)"
                        alt="product"
                      />
                    </a>
                    <a href="javascript:void(0);">{{ record.CategoryName }}</a>
                  </div>
                </template>
                <template v-if="column.key === 'type_client'">
                  <div>
                    <span
                      :class="
                        record.type_client == 'FOURNISSEUR'
                          ? 'badge bg-info badge-lg'
                          : record.type_client == 'CLIENT'
                          ? 'badge bg-success badge-lg'
                          : 'badge bg-primary badge-lg'
                      "
                      >{{ record.type_client }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <!-- <a class="me-2 p-2" href="javascript:void(0);">
                        <i data-feather="eye" class="feather-eye"></i>
                      </a> -->
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-units"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <customers-modal
    @client-added="onClientAdded"
    @client-updated="onClientUpdated"
    :data="selectedClient"
  ></customers-modal>
</template>
<script>
import { getClientsData, deleteClient } from "@/services/clientsService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl } from "@/services/companyService";
import { toast } from "vue3-toastify";
const columns = [
  {
    title: "Réf",
    dataIndex: "ref",
  },
  {
    title: "Nom",
    dataIndex: "nom",
  },
  {
    title: "Prénom",
    dataIndex: "prenom",
  },
  {
    title: "CIN",
    dataIndex: "cin",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Numéro de télephone",
    dataIndex: "telephone",
  },
  {
    title: "Type Client",
    key: "type_client",
    dataIndex: "type_client",
  },
  {
    title: "Ville",
    dataIndex: "ville",
  },
  {
    title: "Pays",
    dataIndex: "pays",
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
import Swal from "sweetalert2";
export default {
  data() {
    return {
      filter: false,
      CustomerCountry: ["Tous les pays"],
      CustomerName: ["Tous les clients"],
      CustomerDate: ["Trier par date", "Plus récent", "Plus ancien"],
      data,
      columns,
      selectedClient: {},
      filteredData: [],
      activeFilters: {
        name: null,
        country: null,
      },
      searchQuery: "",
    };
  },
  methods: {
    getErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (!data) return (error && error.message) || "Une erreur est survenue.";
      if (typeof data === "string") return data;
      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstVal = data.errors[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) return firstVal[0];
        if (typeof firstVal === "string") return firstVal;
      }
      if (data.error) return data.error;
      if (data.message) return data.message;
      return "Une erreur est survenue.";
    },
    refreshList() {
      // Recharger à partir de la source (localStorage ou API)
      this.getClientsData().then(() => {
        this.updateFilters();
        this.applyFilters();
      });
    },
    updateFilters() {
      const names = Array.from(
        new Set(this.data.map((c) => (c.nom ? c.nom.toString() : "")))
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "fr"));
      const countries = Array.from(
        new Set(this.data.map((c) => (c.pays ? c.pays.toString() : "")))
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "fr"));
      this.CustomerName = ["Tous les clients", ...names];
      this.CustomerCountry = ["Tous les pays", ...countries];
    },
    applyFilters() {
      // Basic filter by selected name/country
      const name = this.activeFilters.name && this.activeFilters.name !== "Tous les clients" ? this.activeFilters.name : null;
      const country = this.activeFilters.country && this.activeFilters.country !== "Tous les pays" ? this.activeFilters.country : null;
      const q = (this.searchQuery || "").toString().toLowerCase().trim();
      this.filteredData = this.data.filter((c) => {
        const okName = name ? c.nom === name : true;
        const okCountry = country ? c.pays === country : true;
        const okQuery = q
          ? [
              c.ref,
              c.nom,
              c.prenom,
              c.cin,
              c.email,
              c.telephone,
              c.type_client,
              c.ville,
              c.pays,
            ]
              .filter(Boolean)
              .map((v) => v.toString().toLowerCase())
              .some((v) => v.includes(q))
          : true;
        return okName && okCountry && okQuery;
      });
    },
    exportCSV() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const headers = [
        "Réf",
        "Nom",
        "Prénom",
        "CIN",
        "Email",
        "Téléphone",
        "Type Client",
        "Ville",
        "Pays",
      ];
      const csv = [
        headers.join(","),
        ...rows.map((r) =>
          [
            r.ref || `TIR-0${r.id}`,
            r.nom || "",
            r.prenom || "",
            r.cin || "",
            r.email || "",
            r.telephone || "",
            r.type_client || "",
            r.ville || "",
            r.pays || "",
          ]
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(",")
        ),
      ].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `clients_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async exportPDF() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows.length) return;
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;
      let logo = null;
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore logo load */ }
      const drawHeader = () => {
        if (!logo) return;
        const w = 42, h = 16, x = (pageWidth - w) / 2, y = 8;
        try {
          const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(logo, fmt, x, y, w, h);
        } catch (_) { /* ignore addImage */ }
      };
      const body = rows.map((r) => [
        r.ref || `TIR-0${r.id}`,
        r.nom || "",
        r.prenom || "",
        r.cin || "",
        r.email || "",
        r.telephone || "",
        r.type_client || "",
        r.ville || "",
        r.pays || "",
      ]);
      autoTable(doc, {
        startY: headerHeight,
        head: [["Réf", "Nom", "Prénom", "CIN", "Email", "Téléphone", "Type Client", "Ville", "Pays"]],
        body,
        headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 22 },
          1: { cellWidth: 24 },
          2: { cellWidth: 24 },
          3: { cellWidth: 22 },
          4: { cellWidth: 40 },
          5: { cellWidth: 26 },
          6: { cellWidth: 26, halign: 'center' },
          7: { cellWidth: 22 },
          8: { cellWidth: 22 },
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: () => {
          drawHeader();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: headerHeight + 4, bottom: 15 }
      });
      doc.save(`clients_${new Date().toISOString().slice(0,10)}.pdf`);
    },
    printTable() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      const tableHtml = `
        <html><head><title>Liste des Tiers</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Tiers</h3>
        <table>
          <thead>
            <tr>
              <th>Réf</th><th>Nom</th><th>Prénom</th><th>CIN</th><th>Email</th><th>Téléphone</th><th>Type Client</th><th>Ville</th><th>Pays</th>
            </tr>
          </thead>
          <tbody>
            ${rows
              .map(
                (r) => `
                <tr>
                  <td>${r.ref || `TIR-0${r.id}`}</td>
                  <td>${r.nom || ""}</td>
                  <td>${r.prenom || ""}</td>
                  <td>${r.cin || ""}</td>
                  <td>${r.email || ""}</td>
                  <td>${r.telephone || ""}</td>
                  <td>${r.type_client || ""}</td>
                  <td>${r.ville || ""}</td>
                  <td>${r.pays || ""}</td>
                </tr>`
              )
              .join("")}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(tableHtml);
      win.document.close();
      // Ensure the print dialog opens after the content is ready
      setTimeout(() => {
        try { win.focus(); } catch (e) { /* ignore */ }
        try { win.print(); } catch (e) { /* ignore */ }
      }, 100);
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Client ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteClient(id);
            if (localStorage.getItem("clients") != null) {
              let clients = JSON.parse(localStorage.getItem("clients"));
              clients = clients.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(clients);
              localStorage.setItem("clients", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Votre Client a été supprimé.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(this.getErrorMessage(error));
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getClientsData() {
      this.data = [];
      if (localStorage.getItem("clients") != null) {
        const data = JSON.parse(localStorage.getItem("clients"));
        data.map((m) => {
          this.data.push({
            id: m.id,
            ref: "TIR-0" + m.id,
            adresse: m.adresse,
            informations_complementaires: m.informations_complementaires,
            ville: m.ville,
            pays: m.pays,
            civilite: m.civilite,
            nom: m.nom,
            prenom: m.prenom,
            cin: m.cin,
            email: m.email,
            telephone: m.telephone,
            type: m.type,
            type_client: m.type_client,
            user_id: m.user_id,
            plafond_credit: m.plafond_credit,
            delai_paiement: m.delai_paiement,
            societe_id: m.societe_id,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getClientsData();
          data.map((m) => {
            this.data.push({
              id: m.id,
              ref: "TIR-0" + m.id,
              adresse: m.adresse,
              informations_complementaires: m.informations_complementaires,
              ville: m.ville,
              pays: m.pays,
              civilite: m.civilite,
              nom: m.nom,
              prenom: m.prenom,
              cin: m.cin,
              email: m.email,
              telephone: m.telephone,
              type: m.type,
              type_client: m.type_client,
              user_id: m.user_id,
              plafond_credit: m.plafond_credit,
              delai_paiement: m.delai_paiement,
              societe_id: m.societe_id,
              nom_societe: m.nom_societe,
              rc: m.rc,
              tp: m.tp,
              ice: m.ice,
              identifiant_fiscal: m.identifiant_fiscal,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(this.getErrorMessage(error));
        }
      }
      // Init filteredData and filters after loading
      this.filteredData = [...this.data];
      this.updateFilters();
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    onClientAdded(client) {
      const today = new Date();
      if (localStorage.getItem("clients") != null) {
        let clients = JSON.parse(localStorage.getItem("clients"));
        clients.push({
          id: client.id,
          adresse: client.adresse,
          informations_complementaires: client.informations_complementaires,
          ville: client.ville,
          pays: client.pays,
          civilite: client.civilite,
          nom: client.nom,
          prenom: client.prenom,
          cin: client.cin,
          email: client.email,
          telephone: client.telephone,
          type: client.type,
          type_client: client.type_client,
          user_id: client.user_id,
          plafond_credit: client.plafond_credit,
          delai_paiement: client.delai_paiement,
          societe_id: client.societe_id,
          created_at: client.created_at,
        });
        const jsonData = JSON.stringify(clients);
        localStorage.setItem("clients", jsonData);
      }

      this.data.push({
        id: client.id,
        ref: "TIR-0" + client.id,
        adresse: client.adresse,
        informations_complementaires: client.informations_complementaires,
        ville: client.ville,
        pays: client.pays,
        civilite: client.civilite,
        nom: client.nom,
        prenom: client.prenom,
        cin: client.cin,
        email: client.email,
        telephone: client.telephone,
        type: client.type,
        type_client: client.type_client,
        user_id: client.user_id,
        plafond_credit: client.plafond_credit,
        delai_paiement: client.delai_paiement,
        societe_id: client.societe_id,
        nom_societe: client.nom_societe,
        rc: client.rc,
        tp: client.tp,
        ice: client.ice,
        identifiant_fiscal: client.identifiant_fiscal,
        CreatedOn: today.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        }),
      });
      this.updateFilters();
      this.applyFilters();

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Client créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    onClientUpdated(client) {
      if (localStorage.getItem("clients") != null) {
        let clients = JSON.parse(localStorage.getItem("clients"));
        clients.map((m) => {
          if (m.id == client.id) {
            m.adresse = client.adresse;
            m.informations_complementaires =
              client.informations_complementaires;
            m.ville = client.ville;
            m.pays = client.pays;
            m.civilite = client.civilite;
            m.nom = client.nom;
            m.prenom = client.prenom;
            m.cin = client.cin;
            m.email = client.email;
            m.telephone = client.telephone;
            m.type = client.type;
            m.type_client = client.type_client;
            m.user_id = client.user_id;
            m.plafond_credit = client.plafond_credit;
            m.delai_paiement = client.delai_paiement;
            m.societe_id = client.societe_id;
          }
        });
        const jsonData = JSON.stringify(clients);
        localStorage.setItem("clients", jsonData);
      }

      this.data.map((m) => {
        if (m.id == client.id) {
          m.id = client.id;
          m.ref = "TIR-0" + client.id;
          m.adresse = client.adresse;
          m.informations_complementaires = client.informations_complementaires;
          m.ville = client.ville;
          m.pays = client.pays;
          m.civilite = client.civilite;
          m.nom = client.nom;
          m.prenom = client.prenom;
          m.cin = client.cin;
          m.email = client.email;
          m.telephone = client.telephone;
          m.type = client.type;
          m.type_client = client.type_client;
          m.user_id = client.user_id;
          m.plafond_credit = client.plafond_credit;
          m.delai_paiement = client.delai_paiement;
          m.societe_id = client.societe_id;
          m.nom_societe = client.nom_societe;
          m.rc = client.rc;
          m.tp = client.tp;
          m.ice = client.ice;
          m.identifiant_fiscal = client.identifiant_fiscal;
        }
      });
      this.updateFilters();
      this.applyFilters();

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Client modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    openEditModal(item) {
      this.selectedClient = item;
    },
  },
  mounted() {
    this.getClientsData();
  },
  watch: {
    searchQuery() {
      this.applyFilters();
    },
    'activeFilters.name'() {
      this.applyFilters();
    },
    'activeFilters.country'() {
      this.applyFilters();
    },
  },
};
</script>
